/**
 * Tiếng Việt.
 *
 * House terms follow what Vietnamese players already read on comparable sites:
 * nạp tiền for deposit, rút tiền for withdrawal, vòng cược for turnover /
 * rollover, tiền thưởng for the bonus balance and khuyến mãi for promotions.
 *
 * Vietnamese runs roughly 20–30% longer than English, and this is the locale
 * that breaks layouts first. Strings that sit inside a fixed-width control —
 * tab labels, chips, buttons — are kept deliberately short here even where a
 * fuller phrase would read better, because a wrapped tab bar is worse than a
 * terse label.
 */
export default {
  common: {
    loading: "Đang tải…",
    cancel: "Huỷ",
    save: "Lưu",
    saving: "Đang lưu…",
    close: "Đóng",
    back: "Quay lại",
    copy: "Sao chép",
    copied: "Đã sao chép",
    all: "Tất cả",
    max: "Tối đa",
    optional: "không bắt buộc",
    somethingWrong: "Đã xảy ra lỗi. Vui lòng thử lại.",
    signIn: "Đăng nhập",
    register: "Đăng ký",
    signOut: "Đăng xuất",
  },

  nav: {
    lobby: "Trò chơi",
    money: "Tài chính",
    promotions: "Khuyến mãi",
    vip: "VIP",
    rebate: "Hoàn trả",
    invite: "Mời bạn",
    winLoss: "Thắng / thua",
    account: "Tài khoản",
    language: "Ngôn ngữ",
  },

  menu: {
    soon: "Sắp có",
    notSignedIn: "Chưa đăng nhập",
    menu: "Menu",
    closeMenu: "Đóng menu",

    play: "Chơi",
    money: "Tài chính",
    rewards: "Phần thưởng",
    account: "Tài khoản",
    help: "Trợ giúp",

    games: "Trò chơi",
    bonuses: "Khuyến mãi",
    moneyPage: "Tài chính",
    rebate: "Tỷ lệ hoàn trả",
    invite: "Mời bạn bè",
    vip: "VIP",
    leaderboard: "Bảng xếp hạng",
    myAccount: "Tài khoản của tôi",
    winLoss: "Thắng / thua",
    howItWorks: "Hướng dẫn",
    contact: "Trợ giúp & liên hệ",
  },

  footer: {
    help: "Trợ giúp",
    legal: "Pháp lý",
    terms: "Điều khoản & điều kiện",
    privacy: "Chính sách bảo mật",
    deposits: "Hướng dẫn nạp tiền",
    withdrawals: "Hướng dẫn rút tiền",
    responsible: "Chỉ dành cho người từ 18 tuổi. Vui lòng chơi có trách nhiệm.",
  },

  authGate: {
    title: "Đăng nhập để tiếp tục",
    body: "Bạn có thể xem mọi thứ tại đây. Nhưng để chơi, nạp tiền hoặc nhận khuyến mãi, bạn cần một tài khoản — chỉ mất chưa đầy một phút.",
    createAccount: "Tạo tài khoản",
  },

  prompt: {
    titleAction: "Đăng nhập để {action}",
    title: "Đăng nhập để tiếp tục",
    body: "Bạn cần một tài khoản tại {site} để làm điều đó. Chỉ mất một phút và bạn sẽ quay lại ngay đây.",
    createAccount: "Tạo tài khoản",
    haveOne: "Tôi đã có tài khoản",
    keepLooking: "Xem tiếp đã",
    us: "chúng tôi",
    playGame: "chơi {game}",
  },

  auth: {
    signInToPlay: "Đăng nhập để chơi",
    username: "Tên đăng nhập",
    password: "Mật khẩu",
    tabUsername: "Tên đăng nhập",
    tabEmail: "Email",
    tabPhone: "Điện thoại",
    emailPlaceholder: "you@example.com",
    phonePlaceholder: "Số điện thoại của bạn",
    sessionExpired: "Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.",
    signingIn: "Đang đăng nhập…",
    forgotPassword: "Quên mật khẩu?",
    createAccount: "Tạo tài khoản",

    resetTitle: "Đặt lại mật khẩu",
    resetSent: "Nếu địa chỉ đó đã đăng ký, mã xác nhận đã được gửi đi.",
    resetSentHint: "Mã hết hạn sau 10 phút và chỉ dùng được một lần.",
    enterMyCode: "Nhập mã của tôi",
    backToSignIn: "Quay lại đăng nhập",
    email: "Địa chỉ email",
    sending: "Đang gửi…",
    sendResetCode: "Gửi mã đặt lại",

    newPasswordTitle: "Chọn mật khẩu mới",
    passwordUpdated: "Đã cập nhật mật khẩu. Đang đưa bạn tới trang đăng nhập…",
    resetCode: "Mã đặt lại",
    resetCodeHint: "Mã 6 chữ số chúng tôi đã gửi tới email của bạn. Mã hết hạn sau 10 phút.",
    newPassword: "Mật khẩu mới",
    passwordRule: "Ít nhất 10 ký tự.",
    confirmPassword: "Xác nhận mật khẩu",
    updating: "Đang cập nhật…",
    updatePassword: "Cập nhật mật khẩu",
    requestNewCode: "Yêu cầu mã mới",
  },

  account: {
    title: "Tài khoản của tôi",
    sectionAccount: "Tài khoản",
    sectionSecurity: "Bảo mật",
    sectionPreferences: "Tuỳ chọn",

    verification: "Xác minh",
    verified: "Đã xác minh",
    accountsOnFile: "Đã lưu {count} tài khoản ngân hàng.",
    accountsOnFilePlural: "Đã lưu {count} tài khoản ngân hàng.",
    beingChecked: "Đang kiểm tra",
    beingCheckedDetail: "Thường xong trong vài giờ.",
    notAccepted: "Không được chấp nhận",
    notAcceptedDetail: "Kiểm tra lại thông tin và thử lại.",
    notFinished: "Chưa hoàn tất",
    notFinishedDetail: "Thông tin của bạn đã được lưu nhưng chưa gửi cho chúng tôi.",
    notStarted: "Chưa bắt đầu",
    notStartedDetail: "Cần hoàn tất trước lần rút tiền đầu tiên để chúng tôi biết chuyển tiền tới đâu.",
    manageBanks: "Quản lý tài khoản ngân hàng",
    addBank: "Thêm tài khoản ngân hàng",

    password: "Mật khẩu",
    passwordIntro: "Chúng tôi vẫn hỏi mật khẩu hiện tại dù bạn đã đăng nhập — một phiên đăng nhập không chứng minh được ai đang cầm máy.",
    currentPassword: "Mật khẩu hiện tại",
    newPassword: "Mật khẩu mới",
    newPasswordHint: "Ít nhất 10 ký tự. Một cụm từ ngắn bạn nhớ được tốt hơn một chuỗi ký tự lộn xộn.",
    confirmNewPassword: "Xác nhận mật khẩu mới",
    changePassword: "Đổi mật khẩu",

    currency: "Đơn vị tiền tệ",
    currencyIntro: "Chỉ đổi được khi số dư bằng 0 và trước giao dịch đầu tiên. Sau đó việc đổi sẽ làm sai lệch ý nghĩa các sao kê cũ, nên phải nhờ hỗ trợ trực tuyến.",
    chooseCurrency: "Chọn đơn vị tiền tệ",
    changeCurrency: "Đổi đơn vị tiền tệ",
  },

  verifyEmail: {
    title: "Xác nhận địa chỉ email của bạn",
    sentTo: "Chúng tôi đã gửi mã 6 chữ số tới",
    enterIt: "Nhập mã để hoàn tất thiết lập tài khoản.",
    checking: "Đang kiểm tra…",
    verify: "Xác nhận",
    resending: "Đang gửi…",
    resend: "Gửi lại mã",
    useDifferent: "Dùng tài khoản khác",
    expires: "Mã hết hạn sau 10 phút.",
  },

  register: {
    title: "Tạo tài khoản của bạn",
    email: "Địa chỉ email",
    emailHint: "Chúng tôi sẽ gửi mã 6 chữ số để xác nhận.",
    signInInstead: "Đăng nhập thay vì đăng ký",
    sending: "Đang gửi…",
    sendCode: "Gửi mã",

    enterCodeSentTo: "Nhập mã chúng tôi đã gửi tới",
    verificationCode: "Mã xác nhận",
    checking: "Đang kiểm tra…",
    continue: "Tiếp tục",
    useDifferentEmail: "Dùng email khác",
    resend: "Gửi lại",

    username: "Tên đăng nhập",
    usernameHint: "Chữ cái, chữ số và dấu gạch dưới.",
    password: "Mật khẩu",
    passwordHint: "Ít nhất 10 ký tự.",
    confirmPassword: "Xác nhận mật khẩu",
    fullName: "Họ và tên",
    fullNameHint: "Phải trùng khớp hoàn toàn với tên chủ tài khoản ngân hàng — dùng cho nạp và rút tiền.",
    nickname: "Biệt danh",
    nicknameHint: "Tên mà người chơi khác nhìn thấy.",
    phoneCode: "Mã vùng",
    phone: "Số điện thoại",
    creating: "Đang tạo…",
    createAccount: "Tạo tài khoản",
    alreadyHave: "Đã có tài khoản?",

    needsMore: "Cần thêm {count} ký tự.",
    needsMorePlural: "Cần thêm {count} ký tự.",
    passwordsDoNotMatch: "Mật khẩu không khớp.",
    nicknameRequired: "Chọn biệt danh — ít nhất 3 chữ cái hoặc chữ số.",
    phoneRequired: "Nhập số điện thoại của bạn.",
    fullNameRequired: "Nhập họ tên đúng như trên tài khoản ngân hàng của bạn.",
  },

  bank: {
    title: "Tài khoản ngân hàng của bạn",
    intro: "Tiền rút chỉ chuyển vào tài khoản bạn đã lưu và chúng tôi đã kiểm tra — không bao giờ vào tài khoản gõ vào lúc rút. Đó là điều giữ cho tiền của bạn chỉ mình bạn lấy được.",
    confirmed: "Đã xác nhận",
    weCanPayAny: "Chúng tôi có thể chuyển vào bất kỳ tài khoản nào dưới đây",
    wePayInto: "Chúng tôi chuyển vào",
    pickAtWithdrawal: "Bạn chọn tài khoản khi rút tiền. Tất cả đều phải đứng tên chính bạn — đó là điều chúng tôi kiểm tra trước khi thêm.",
    checkingNew: "Chúng tôi đang kiểm tra tài khoản mới của bạn.",
    carryOnMeantime: "Trong thời gian đó, việc rút tiền vẫn diễn ra bình thường vào các tài khoản ở trên.",
    spottedMistake: "Phát hiện sai sót? Nhắn cho hỗ trợ trực tuyến — yêu cầu không sửa được sau khi đã gửi.",
    couldNotApprove: "Chúng tôi không thể duyệt thay đổi lần trước của bạn.",
    maxAccounts: "Bạn đã lưu tối đa {count} tài khoản. Nhắn cho hỗ trợ trực tuyến nếu cần xoá bớt.",
    tryAgain: "Thử lại",
    addAnother: "Thêm tài khoản ngân hàng khác",

    bankLabel: "Ngân hàng",
    selectYourBank: "Chọn ngân hàng của bạn",
    otherTypeBelow: "Khác — nhập bên dưới",
    bankNamePlaceholder: "Tên ngân hàng",
    holderName: "Tên chủ tài khoản",
    accountNumber: "Số tài khoản",
    whyAdding: "Vì sao bạn thêm tài khoản này?",
    stillHasToBe: "Vẫn phải là {name} — khác ngân hàng thì được, khác người thì không.",
    sending: "Đang gửi…",
    sendForChecking: "Gửi đi kiểm tra",

    weAreChecking: "Chúng tôi đang kiểm tra",
    sentAt: "Đã gửi {when}. Thường xong trong vài giờ.",
    couldNotConfirm: "Chúng tôi không thể xác nhận tài khoản này",
    checkAndRetry: "Kiểm tra lại thông tin ngân hàng và thử lại.",

    addYours: "Thêm tài khoản ngân hàng của bạn",
    neededBefore: "Cần hoàn tất trước lần rút tiền đầu tiên để chúng tôi biết chuyển tiền tới đâu. Chỉ cần thông tin ngân hàng — không cần giấy tờ.",
    starting: "Đang bắt đầu…",
    start: "Bắt đầu",

    yourDetails: "Thông tin ngân hàng của bạn",
    mustComeFrom: "Tiền phải đến từ tài khoản này, và chúng tôi cũng chỉ chuyển trả về đúng tài khoản đó.",
    hasToMatch: "Phải trùng với tên trên tài khoản của bạn:",
    weWillSave: "Chúng tôi sẽ lưu tên này và đối chiếu mọi khoản tiền ra vào với nó.",
    doesNotMatch: "Tên này không khớp với tên trên tài khoản của bạn. Nhắn cho hỗ trợ trực tuyến nếu bạn đã đổi tên.",
    matches: "✓ Trùng khớp với tên trên tài khoản của bạn.",
    finishLaterTitle: "Lưu thông tin này mà chưa gửi đi",
    finishLater: "Hoàn tất sau",
  },

  misc: {
    siteUnavailable_title: "Trang không khả dụng",
    verifyYourEmail: "Xác nhận email của bạn",
    reasonGiven: "Lý do",
    createAccount: "Tạo tài khoản",
    seeBonuses: "Xem khuyến mãi",

    siteUnavailable: "Trang này hiện không truy cập được. Vui lòng kiểm tra lại địa chỉ và thử lại.",
    notifications: "Thông báo",
    needAttention: "{count} việc cần bạn xử lý",
    allCaughtUp: "Bạn đã xem hết rồi.",
    qrAlt: "Địa chỉ nạp tiền dạng mã QR",
    qrTooLong: "Địa chỉ này quá dài để hiển thị dạng mã — vui lòng sao chép thay vì quét.",
    youSubmitted: "Bạn đã gửi",
    enterCodeWeSent: "Nhập mã 6 chữ số chúng tôi đã gửi cho bạn.",
    sentAgain: "Đã gửi lại",
    resend: "Gửi lại",
  },

  support: {
    help: "Trợ giúp",
    tabChat: "Trò chuyện",
    tabFaq: "Câu hỏi thường gặp",
    tabContact: "Liên hệ",
    automatedNotice: "Đây là câu trả lời tự động. Với bất cứ việc gì liên quan tới tài khoản hoặc tiền của bạn, hãy dùng WhatsApp trong mục Liên hệ — ở đó có người thật xem được.",
    openWhatsApp: "Mở WhatsApp →",
    whatsappIntro: "WhatsApp là cách nhanh nhất để liên hệ với chúng tôi, và là kênh duy nhất chúng tôi xem được tài khoản của bạn.",
    demoNumber: "Số demo — không có ai ở đầu bên kia. Hãy đặt số thật trong phần cài đặt thương hiệu của trang trước khi ra mắt.",
  },

  legal: {
    notRealTitle: "Đây không phải văn bản chính thức.",
    notRealBody: "Đây chỉ là bản phác thảo các mục mà {brand} cần, không phải văn bản pháp lý đã được rà soát, và không ràng buộc bất kỳ ai. Nó phải được thay bằng nội dung soạn riêng cho nhà điều hành này, giấy phép của họ và các thị trường họ nhận người chơi, trước khi trang đi vào hoạt động.",
    englishOnly: "Bản nháp này chỉ được công bố bằng tiếng Anh. Nó sẽ được dịch khi nội dung cuối cùng được chốt — một bản dịch máy của thoả thuận không phải là thoả thuận.",
    version: "Phiên bản: bản nháp chưa công bố. Không có ngày hiệu lực.",
    notFound: "Không tìm thấy văn bản.",
  },

  live: {
    title: "Cược trực tiếp",
    playing: "{count} người đang chơi",
    quiet: "Hiện chưa có ai đang chơi.",
    quietBody: "Các lượt cược sẽ hiện ở đây khi được kết toán.",
    stat_paid: "Đã chi trả hôm nay",
    stat_biggest: "Thắng lớn nhất hôm nay",
    stat_rounds: "Số ván hôm nay",
    topToday: "Thắng lớn nhất hôm nay",
    noWins: "Hôm nay chưa có lượt thắng nào.",
    won: "thắng",
    staked: "đã cược",
  },

  providers: {
    title: "Nhà phát hành trò chơi",
    subtitle: "Trò chơi do các nhà phát hành có giấy phép cung cấp.",
  },

  trust: {
    licensed: "Nhà điều hành có giấy phép",
    licensedBody: "Hoạt động theo giấy phép nêu trong điều khoản của chúng tôi.",
    payouts: "Rút tiền trong ngày",
    payoutsBody: "Được người thật kiểm tra, thường trong vài phút.",
    support: "Hỗ trợ suốt ngày đêm",
    supportBody: "Trò chuyện trực tuyến, mỗi ngày.",
    fair: "Kết toán minh bạch",
    fairBody: "Mọi ván chơi đều được ghi lại và có thể kiểm tra.",
  },

  help: {
    title: "Hướng dẫn",
    intro: "Những hướng dẫn ngắn cho các câu hỏi thường gặp nhất.",
    openIt: "Tới ngay",
    stepsLabel: "{count} bước",

    deposit_title: "Cách nạp tiền",
    deposit_body: "Mở mục Tài chính, chọn loại tiền bạn nạp, rồi chọn cách thanh toán. Bạn sẽ thấy tài khoản hoặc địa chỉ ví để chuyển tới, kèm mã tham chiếu cần ghi. Bấm \"Tôi đã thanh toán\" sau khi đã chuyển — thao tác này đưa lệnh nạp vào hàng chờ chứ chưa cộng tiền. Mỗi khoản đều có người kiểm tra, thường chỉ vài phút. Số dư cập nhật ngay khi được xác nhận.",
    deposit_note: "Tiền phải đến từ tài khoản đứng tên chính bạn. Khoản thanh toán từ người khác không thể được cộng.",

    withdraw_title: "Cách rút tiền",
    withdraw_body: "Hãy lưu tài khoản ngân hàng trước — chúng tôi chỉ chuyển vào tài khoản bạn đã lưu và đã được kiểm tra, không bao giờ vào tài khoản gõ vào lúc rút. Mở Tài chính, chọn Rút tiền, nhập số tiền và xác nhận. Số tiền được giữ lại ngay khi bạn gửi yêu cầu nên rời khỏi số dư chơi được lập tức.",
    withdraw_note: "Tên trên tài khoản ngân hàng phải trùng khớp hoàn toàn với tên tài khoản của bạn. Bạn có thể huỷ yêu cầu trong mục Lịch sử khi nó còn đang chờ, và tiền sẽ quay lại.",

    bonus_title: "Tiền thưởng và tiền mặt",
    bonus_body: "Tiền thưởng chưa thuộc về bạn cho tới khi hoàn thành vòng cược. Mỗi khoản thưởng có yêu cầu vòng cược riêng, ấn định ngay khi được cấp, và lượt chơi sẽ trừ vào khoản cũ nhất trước. Khi hoàn thành, tiền thưởng trở thành tiền mặt và rút được như bình thường.",
    bonus_note: "Tab Chuyển hiển thị còn bao nhiêu vòng cược nữa và bao nhiêu đã sẵn sàng để chuyển.",

    rebate_title: "Hoàn trả",
    rebate_body: "Bạn nhận lại một phần của mọi khoản đã cược, dù thắng hay thua — tính trên số tiền cược, không phải trên số tiền thua. Được tổng kết mỗi ngày một lần và cộng vào số dư tiền thưởng. Tỷ lệ tuỳ theo nhà cung cấp trò chơi, và cấp VIP của bạn còn được cộng thêm.",
    rebate_note: "Tỷ lệ hiện hành của từng nhà cung cấp có trên trang Hoàn trả.",

    stillStuck: "Vẫn chưa rõ?",
    stillStuckBody: "Hỗ trợ trực tuyến mở suốt ngày đêm và xem được tài khoản của bạn.",
    contactUs: "Nhắn cho chúng tôi",
  },

  lobby: {
    categories: {
      slots: "Nổ hũ",
      live: "Casino trực tuyến",
      sports: "Thể thao",
      fishing: "Bắn cá",
      lottery: "Xổ số 4D",
      cockfight: "Đá gà",
      horse: "Đua ngựa",
      esports: "Thể thao điện tử",
    },

    banners: {
      welcomeTitle: "Thưởng chào mừng",
      welcomeBody: "Thêm tới 150% cho lần nạp đầu tiên",
      cashbackTitle: "Hoàn tiền mỗi ngày",
      cashbackBody: "Nhận lại một chút sau mỗi ván chơi",
      friendTitle: "Rủ bạn bè",
      friendBody: "Cả hai cùng có thưởng",
    },

    trust: {
      withdraw: "Rút tiền",
      withdrawValue: "Trong ngày",
      chat: "Hỗ trợ trực tuyến",
      chatValue: "Luôn sẵn sàng",
      payBy: "Thanh toán",
      payByValue: "Ngân hàng hoặc USDT",
    },

    popular: "Phổ biến",
    notConnected: "Trò chơi này chưa được kết nối.",
    notConnectedTry: "Trò chơi này chưa được kết nối. Vui lòng chọn trò khác.",
    showSlide: "Xem ảnh {number}",
    dismiss: "Đóng",
    winningNow: "Đang thắng",
    pickAGame: "Chọn trò chơi",
    comingSoon: "Sắp có",
    showAll: "Xem tất cả",
    gamesOnTheWay: "Trò chơi sắp ra mắt",
    hot: "HOT",
    gameStudios: "Nhà phát hành",
    bonuses: "Khuyến mãi",
    viewAll: "Xem tất cả",
    bonus: "Thưởng",
  },

  vip: {
    title: "VIP",
    intro: "Cấp bậc của bạn được tính theo tổng số tiền đã nạp từ trước tới nay. Nó không bao giờ giảm.",
    currentTier: "Cấp hiện tại",
    depositedToDate: "Đã nạp tới nay",
    toReach: "Để đạt {tier}",
    topTier: "Bạn đang ở cấp cao nhất.",
    allTiers: "Tất cả cấp bậc",
    tier: "Cấp",
    deposited: "Đã nạp",
    extraRebate: "Hoàn trả thêm",
    includes: "Quyền lợi",
    you: "Bạn",
    orMore: "Từ {amount}",
    notPaidTitle: "Thưởng hoàn trả theo cấp chưa được chi trả.",
    notPaidBody: "Cấp bậc và số tiền nạp của bạn được ghi nhận từ bây giờ, và hoàn trả tiêu chuẩn vẫn được trả như đã công bố. Chúng tôi sẽ thông báo tại đây khi thưởng theo cấp bắt đầu áp dụng.",
  },

  promotions: {
    title: "Khuyến mãi",
    intro: "Mọi chương trình đang chạy trên trang này, kèm điều khoản đầy đủ.",
    hideTerms: "Ẩn điều khoản",
    readTerms: "Xem điều khoản",
    draftTitle: "Các điều khoản này là bản nháp.",
    draftBody: "Các con số, ngày tháng và tên nhà cung cấp ở trên chỉ là nội dung tạm và sẽ được xác nhận trước khi bất kỳ ưu đãi nào được công bố. Bản thân các quy tắc — mức chi trả tối thiểu, biên hoàn trả VIP và các hạng mục loại trừ — đã có hiệu lực và được trả đúng như mô tả.",
  },

  rebate: {
    title: "Tỷ lệ hoàn trả",
    intro: "Nhận được ở mọi ván chơi, dù thắng hay thua.",
    settingUp: "Tỷ lệ hoàn trả đang được thiết lập và sẽ hiển thị tại đây trong ít phút nữa.",
    toYou: "cho bạn",
    referral: "Giới thiệu",
    shareholder: "Cổ đông",
    supplier: "Nhà cung cấp",
    you: "Bạn",
    howItAddsUp: "Cách tính",
    example: "Hoàn trả tính trên số tiền bạn cược, không phải trên số tiền bạn thua.",
    exampleFull: "Hoàn trả tính trên số tiền bạn cược, không phải trên số tiền bạn thua. Cược {stake} ở nổ hũ với tỷ lệ {rate} thì bạn nhận lại {reward} — dù các ván đó thắng hay thua.",
    exampleDaily: "Được tổng kết mỗi ngày và cộng vào số dư tiền thưởng của bạn.",
  },

  invite: {
    title: "Mời bạn bè",
    intro: "Chia sẻ mã của bạn. Ai đăng ký qua mã đó đều được ghi nhận là của bạn.",
    yourCode: "Mã của bạn",
    codeCopied: "Đã sao chép mã",
    copyCode: "Sao chép mã",
    yourLink: "Liên kết của bạn",
    joinedThroughYou: "Đăng ký qua bạn",
    namesNotShown: "Tính từ những lượt đăng ký dùng mã của bạn. Chúng tôi không hiển thị tài khoản của họ.",
    noRewardTitle: "Chưa có thưởng giới thiệu nào được chi trả.",
    noRewardBody: "Các lượt đăng ký qua mã của bạn đã được ghi nhận từ bây giờ nên không mất gì — nhưng hoàn trả bạn nhận hôm nay chỉ tính trên lượt chơi của chính bạn. Chúng tôi sẽ thông báo tại đây khi điều đó thay đổi.",
  },

  winLoss: {
    title: "Thắng / thua",
    intro: "Chỉ tính các ván đã kết toán. Cược còn đang chơi không được tính về bên nào.",
    from: "Từ",
    to: "Đến",
    ranges: { today: "Hôm nay", week: "7 ngày qua", month: "30 ngày qua" },
    youAreUp: "Bạn đang lãi",
    youAreDown: "Bạn đang lỗ",
    staked: "Đã cược",
    returned: "Nhận lại",
    rounds: "Số ván",
    byGameType: "Theo loại trò chơi",
    dayByDay: "Theo từng ngày",
    empty: "Không có ván nào đã kết toán trong khoảng này.",
    roundsStaked: "{rounds} ván · đã cược {staked}",
  },

  wallet: {
    title: "Ví",
    systemBalance: "Số dư chính",
    makeADeposit: "Hãy nạp tiền để bắt đầu.",
    setAside: "Đang giữ {amount}",
    addMoney: "Nạp tiền",
    withdraw: "Rút tiền",
    recentActivity: "Hoạt động gần đây",
    empty: "Chưa có gì ở đây.",
  },

  money: {
    title: "Tài chính",
    available: "Số dư khả dụng",
    held: "Đang giữ",
    heldHint: "cho yêu cầu đang được xét duyệt",
    bonus: "Tiền thưởng",
    bonusHint: "hoàn thành vòng cược trước khi rút được",

    tabs: {
      deposit: "Nạp tiền",
      transfer: "Chuyển",
      withdraw: "Rút tiền",
      history: "Lịch sử",
      bank: "Ngân hàng",
    },

    hints: {
      transfer: "Đổi tiền thưởng sang tiền mặt, hoặc gửi cho người chơi khác",
      history: "Mọi giao dịch nạp, rút và biến động số dư",
      bank: "Tài khoản nhận tiền khi bạn rút",
    },
  },

  deposit: {
    noMethodsTitle: "Chưa có phương thức thanh toán",
    noMethodsBody: "Trang này chưa mở phương thức nạp tiền. Vui lòng liên hệ hỗ trợ để được cộng tiền vào tài khoản.",

    ticketNumber: "Lệnh nạp #{id}",
    network: "Mạng lưới",
    sendToAddress: "Gửi tới địa chỉ này",
    copyAddress: "Sao chép địa chỉ",
    wrongNetwork: "Chỉ gửi qua mạng {network}. Tiền gửi qua mạng khác không thể lấy lại được.",

    cardPendingTitle: "Thanh toán thẻ vẫn đang được kết nối.",
    cardPendingBody: "Đội ngũ của chúng tôi sẽ liên hệ để hoàn tất giao dịch này, hoặc bạn có thể huỷ và chọn cách khác.",

    transferTo: "Chuyển {amount} tới:",
    bank: "Ngân hàng",
    accountName: "Chủ tài khoản",
    accountNumber: "Số tài khoản",
    swift: "SWIFT",
    branch: "Chi nhánh",
    copyAccount: "Sao chép số tài khoản",
    quoteReference: "Ghi {reference} vào nội dung chuyển khoản để đối chiếu với tài khoản của bạn.",
    transferToConfirmed: "Chuyển {amount} tới tài khoản mà đội ngũ của chúng tôi xác nhận với bạn.",
    quoteReferenceGeneric: "Ghi mã {reference} khi chuyển khoản để đối chiếu với tài khoản của bạn.",

    expires: "Yêu cầu này hết hạn vào {when}.",
    yourReference: "Mã giao dịch của bạn (không bắt buộc)",
    yourReferencePlaceholder: "Mã hash hoặc mã giao dịch ngân hàng",
    yourReferenceHint: "Giúp duyệt nhanh hơn — chúng tôi dùng nó để đối chiếu khoản thanh toán.",
    iHavePaid: "Tôi đã thanh toán",
    sending: "Đang gửi…",

    checkingTitle: "Cảm ơn — chúng tôi đang kiểm tra khoản thanh toán của bạn.",
    checkingBody: "Số dư sẽ cập nhật ngay khi được xác nhận. Hiện chưa có khoản nào được cộng.",
    makeAnother: "Nạp thêm lần nữa",

    payIn: "Nạp bằng",
    chooseHow: "Chọn cách thanh toán",
    recommended: "Đề xuất",
    selected: "Đã chọn",
    min: "Tối thiểu {amount}",
    max: "Tối đa {amount}",
    addressLabel: "Địa chỉ {network}",

    amount: "Số tiền",
    otherAmount: "Số tiền khác bằng {currency}",
    aboveMaximum: "Mức tối đa mỗi lần của phương thức này là {amount}.",
    belowMinimum: "Mức tối thiểu của phương thức này là {amount}.",
    youWillGet: "Bạn sẽ nhận khoảng",
    rateIndicative: "Chỉ mang tính tham khảo. Tỷ giá áp dụng là tỷ giá tại thời điểm khoản thanh toán được xác nhận.",
    rateStale: "Tỷ giá này đã được kiểm tra khá lâu trước và có thể đã thay đổi.",
    rateUnavailable: "Hiện chưa lấy được tỷ giá {pay}. Khoản nạp của bạn sẽ được quy đổi sang {account} theo tỷ giá tại thời điểm xác nhận.",
    preparing: "Đang xử lý…",
    submit: "Nạp {amount}",

    groups: { instant: "Tức thì", bank: "Ngân hàng & crypto" },
  },

  withdraw: {
    doneTitle: "Đã nhận yêu cầu. Số tiền này đã được giữ lại và không còn nằm trong số dư bạn có thể chơi.",

    blockers: {
      statusTitle: "Tài khoản của bạn đang tạm khoá",
      statusBody: "Việc rút tiền đang tạm dừng. Nhắn cho hỗ trợ trực tuyến và chúng tôi sẽ xử lý.",
      kycTitle: "Cho chúng tôi biết nơi nhận tiền",
      kycBody: "Hãy lưu tài khoản ngân hàng trước — chỉ mất một phút và không cần giấy tờ nào.",
      kycAction: "Thêm tài khoản ngân hàng",
      emailTitle: "Xác nhận email trước đã",
      emailBody: "Nhập mã 6 chữ số chúng tôi đã gửi cho bạn.",
      balanceTitle: "Chưa có gì để rút",
      balanceBody: "Số tiền đã giữ cho một yêu cầu khác không thể rút thêm lần nữa.",
      balanceAction: "Nạp tiền",
      dailyTitle: "Hôm nay đã hết lượt",
      dailyBody: "Bạn đã dùng hết {count} lượt rút tiền hôm nay. Bạn có thể yêu cầu lại vào ngày mai.",
      turnoverTitle: "Sắp xong rồi",
      turnoverBody: "Cược thêm {amount} nữa là bạn có thể rút tiền.",
      turnoverAction: "Chơi ngay",
    },

    sendAs: "Rút bằng",
    noMethods: "Chưa có phương thức rút tiền nào được bật. Nhắn cho hỗ trợ trực tuyến và chúng tôi sẽ giúp bạn.",
    today: "Số lượt rút hôm nay",
    amount: "Số tiền",
    walletAddress: "Địa chỉ ví",
    walletAddressPlaceholder: "Địa chỉ {network} của bạn",
    walletAddressWarning: "Phải là địa chỉ {network}. Chúng tôi không thể lấy lại tiền gửi nhầm mạng.",

    whichAccount: "Tài khoản nào?",
    paidIntoSaved: "Chuyển vào tài khoản ngân hàng đã lưu của bạn",
    noAccountSaved: "Chưa lưu tài khoản ngân hàng nào.",
    onlySavedAccounts: "Tiền rút chỉ chuyển vào tài khoản bạn đã lưu và chúng tôi đã kiểm tra.",
    addAnother: "Thêm tài khoản khác",
    ownName: "— phải đứng tên chính bạn.",

    holdTitle: "Tiền được giữ lại ngay khi bạn gửi yêu cầu.",
    holdBody: "Số tiền rời khỏi số dư bạn có thể chơi ngay lập tức, và chỉ quay lại nếu bạn huỷ hoặc chúng tôi không thể duyệt. Bạn có thể huỷ bất cứ lúc nào trong mục Lịch sử khi yêu cầu còn đang chờ.",
    holdTurnover: "Ngoài ra, bạn cần cược ít nhất bằng số tiền đã nạp trước khi chúng tôi có thể chuyển tiền rút.",

    playRequirement: "Yêu cầu vòng cược",
    requesting: "Đang gửi…",
    submit: "Yêu cầu rút tiền",
  },

  transfer: {
    cash: "Tiền mặt",
    setAside: "Đang giữ {amount}",
    bonus: "Tiền thưởng",

    modes: { bonus: "Thưởng → Tiền mặt", member: "Gửi người chơi" },

    bonusIntro: "Tiền thưởng chưa thuộc về bạn cho tới khi hoàn thành vòng cược. Chuyển sang tiền mặt là lúc nó thành tiền thật.",
    playedThrough: "Đã cược",
    amountToMove: "Số tiền chuyển",
    moving: "Đang chuyển…",
    moveToCash: "Chuyển sang tiền mặt",
    keepPlaying: "Tiếp tục chơi để mở khoá.",

    amount: "Số tiền",
    sendTo: "Gửi tới",
    theirUsername: "Tên đăng nhập của họ",
    note: "Ghi chú",
    checkUsernameTitle: "Kiểm tra kỹ tên đăng nhập.",
    checkUsernameBody: "Tiền chuyển vào thẳng số dư của người chơi đó và không thể hoàn lại.",
    transfersLeft: "Bạn còn {left} / {total} lượt chuyển hôm nay.",
    send: "Gửi",
  },

  history: {
    show: "Hiển thị",
    everything: "Tất cả",
    moneyIn: "Tiền vào",
    moneyOut: "Tiền ra",
    from: "Từ",
    to: "Đến",

    ranges: {
      today: "Hôm nay",
      yesterday: "Hôm qua",
      week: "7 ngày qua",
      month: "30 ngày qua",
    },

    empty: "Không có giao dịch nào trong khoảng này. Thử mở rộng khoảng ngày.",
    cancelHold: "Huỷ và giải phóng số tiền giữ",
    cancelling: "Đang huỷ…",
    requested: "Yêu cầu {amount}",
    shortBy: "thiếu",
    overBy: "dư",

    kind: { deposit: "Nạp tiền", withdrawal: "Rút tiền" },

    status: {
      AwaitingConfirmation: "Chờ xác nhận",
      Pending: "Đang chờ",
      Completed: "Hoàn tất",
      Rejected: "Bị từ chối",
      Cancelled: "Đã huỷ",
      Expired: "Hết hạn",
      Approved: "Đã duyệt",
      Processing: "Đang xử lý",
    },
  },
};
